<template>
  <el-button type="danger" size="mini" plain @click="onSubmit()" title="Delete">
    Delete
  </el-button>
</template>

<script>
export default {
  props: {
    recipeId: String,
    stepId: String,
  },

  methods: {
    async onSubmit() {
      try {
        await this.$confirm('The recipe step will be permanently deleted.', 'Confirm Delete', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
      } catch(err) {
        return false
      }

      try {
        var { data } = await this.$http.delete(`/recipes/${ this.recipeId }/steps/${ this.stepId }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.$emit('delete')
      this.$message.success(data.message)
    },
  },
}
</script>
